<mat-form-field appearance="fill" color="accent" *ngIf="this.input && this.input.length > 1">
  <mat-label>{{ 'popup.pdf_viewer.label' | translate }}</mat-label>
  <mat-select [formControl]="reportControl">
    <mat-option *ngFor="let report of this.input" [value]="report.url">
      {{report.label}}
    </mat-option>
  </mat-select>
</mat-form-field>
<div class="document">
  <ng2-pdfjs-viewer *ngIf="!this.imagePath" #pdfViewer></ng2-pdfjs-viewer>
  <img class="image" *ngIf="this.imagePath" [src]="imagePath" alt="Aperçu de l'image">
</div>
